import { useState } from "react";

const inputStyle = {
  width: "100%",
  padding: "10px 14px",
  backgroundColor: "rgba(255,255,255,0.05)",
  border: "1px solid rgba(255,255,255,0.12)",
  borderRadius: "10px",
  color: "#E7EBEF",
  fontSize: "14px",
  outline: "none",
  transition: "border-color 0.2s, box-shadow 0.2s",
  WebkitBoxShadow: "0 0 0 1000px rgba(13,17,23,0.95) inset",
  WebkitTextFillColor: "#E7EBEF",
};

const labelStyle = {
  display: "block",
  fontSize: "12px",
  fontWeight: 500,
  color: "#94A3B8",
  marginBottom: "6px",
  letterSpacing: "0.03em",
  textTransform: "uppercase",
};

const ForgotPasswordForm = ({
  handleResetPassword,
  resetEmailSent,
  resetEmailError,
  goBackToLogin,
}) => {
  const [focused, setFocused] = useState(false);

  return (
    <div>
      <form className="space-y-4" onSubmit={handleResetPassword}>
        <div>
          <label htmlFor="resetEmail" style={labelStyle}>Email</label>
          <input
            id="resetEmail"
            name="resetEmail"
            type="email"
            required
            placeholder="doctor@hospital.com"
            style={{
              ...inputStyle,
              ...(focused
                ? { borderColor: "#30A69C", boxShadow: "0 0 0 2px rgba(48,166,156,0.2)" }
                : {}),
            }}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
          />
        </div>

        <button
          type="submit"
          className="w-full py-3 px-4 rounded-xl font-semibold mt-2 transition-all duration-200"
          style={{ backgroundColor: "#30A69C", color: "#fff", border: "none" }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#228880")}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#30A69C")}
        >
          Send Reset Email
        </button>

        {resetEmailSent && (
          <p className="text-sm" style={{ color: "#4ADE80", marginTop: "8px" }}>
            Reset password email sent. Please check your inbox.
          </p>
        )}

        {resetEmailError && (
          <p className="text-sm text-red-400 mt-2">{resetEmailError}</p>
        )}

        <p className="mt-3 text-sm text-center">
          <button
            type="button"
            className="transition-colors duration-200"
            style={{ color: "#30A69C" }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "#50C6BC")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "#30A69C")}
            onClick={goBackToLogin}
          >
            ← Back to Login
          </button>
        </p>
      </form>
    </div>
  );
};

export default ForgotPasswordForm;
